// extracted by mini-css-extract-plugin
export default {"info":"wvpwf8raQm","h-rule":"Xj2_edQ0iq","hRule":"Xj2_edQ0iq"};